import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full space-y-2" }
const _hoisted_2 = { class: "flex w-full" }
const _hoisted_3 = {
  key: 0,
  class: "text-brand-pink font-medium text-xs"
}
const _hoisted_4 = {
  key: 1,
  class: "flex text-brand-light-gray font-medium text-xs ml-auto mr-0"
}

import {IonTextarea} from "@ionic/vue";
import {computed, ref, watch} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'InputTextarea',
  props: {
  modelValue: {
    type: String,
  },
  placeholder: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'text'
  },
  enterkeyhint: {
    type: String,
    default: 'return'
  },
  autofocus: {
    type: Boolean,
    default: false
  },
  inputmode: {
    type: String,
    default: 'text'
  },
  error: {
    type: String,
    required: false
  },
  counter: {
    type: Boolean,
    default: false
  },
  maxLength: {
    type: Number,
  },
  autocapitalize: {
    type: String,
    default: 'on'
  },
  autocomplete: {
    type: String,
    default: 'off'
  },
  autocorrect: {
    type: String,
    default: 'off'
  }
},
  emits: ['update:modelValue', 'onKeyEnter'],
  setup(__props, { emit: __emit }) {


const props = __props

const emits = __emit
const model = ref(props.modelValue ?? '')

watch(() => model.value, newValue => {
  emits('update:modelValue', newValue)
})

const keyPressed = (event:any) => {
  if (event.keyCode === 13) emits('onKeyEnter', model)
}

const characterCount = computed(() => {
  if (props.maxLength) return `${model.value.length}/${props.maxLength}`
  return model.value.length
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{
          'border-brand-pink' : __props.error,
          'border-brand-lime' : _ctx.hasFocus
        }, "flex w-full flex-col bg-brand-dark-gray rounded-lg relative border border-brand-dark-gray overflow-hidden"])
    }, [
      _createVNode(_unref(IonTextarea), {
        class: "input-textarea text-white text-lg font-medium",
        modelValue: model.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
        autocomplete: __props.autocomplete,
        autocorrect: __props.autocorrect,
        autocapitalize: __props.autocapitalize,
        "auto-grow": true,
        rows: "5",
        placeholder: __props.placeholder,
        onKeyup: keyPressed,
        enterkeyhint: __props.enterkeyhint,
        maxlength: __props.maxLength,
        type: __props.type
      }, null, 8, ["modelValue", "autocomplete", "autocorrect", "autocapitalize", "placeholder", "enterkeyhint", "maxlength", "type"])
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      (__props.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.error), 1))
        : _createCommentVNode("", true),
      (__props.counter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(characterCount.value), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})